import {NeoModal} from "@/components/@modal/neo.modal";
import {NeoButton, NeoTextBox} from "@/components/forms";
import {routePlanService} from "@/service/routePlan.service";
import {Tooltip} from "@nextui-org/react";
import Image from "next/image";
import {useEffect, useMemo, useState} from "react";
import {AiOutlineLoading} from "react-icons/ai";
import {IoAddOutline} from "react-icons/io5";
import {MdDelete} from "react-icons/md";
export const UserMappingUnMapping = function ({
  routeData,
  userData,
  variantId,
  setCurrentVariant,
  refreshSingleRoute,
  handleCloseModal,
  index
}: {
  routeData: RouteDetails_RP;
  userData: UserBoarding_RP;
  variantId: number;
  setCurrentVariant: any;
  refreshSingleRoute: (routeId: number, bpId: number) => Promise<void>;
  handleCloseModal: any;
  index: number;
}) {
  const [loading, setLoading] = useState(false);
  const [conformModalOpen, setConformModalOpen] = useState(false);
  const [inputSearch, setInputSearch] = useState("");
  const [processingPopupmodal, setProcessingPopupmodal] = useState(false);

  const [conforMationMessage, setConforMationMessage] =
    useState("Nothing Changed");
  const [apiErrorMessage, setApiErrorMessage] = useState("");
  const [confirmPopup, setConfirmPopup] = useState(false);

  const [mappedUsersdata, setMappedUserData] = useState<
    UserBoardingUser_RP[] | null
  >(null);
  const [totalUnMappedUsersdata, setTotalUnMappedUserData] = useState<
    UnMappedUserItem[] | null
  >(null);

  const [unMappedUsersdata, setUnMappedUserData] = useState<
    UnMappedUserItem[] | null
  >(null);
  const [newlyMappedUsers, setNewlyMappedUsers] = useState<
    UnMappedUserItem[] | null
  >([]);
  const [newlyUnMappedUsers, setNewlyUnMappedUsers] = useState<
    UnMappedUserItem[] | null
  >([]);
  const [saveLoading, setSaveLoading] = useState(false);
  const [oldCurrentVariantId, setOldCurrentVariantId] = useState<number | null>(
    null
  );
  useEffect(() => {
    if (userData.users) {
      setMappedUserData(userData.users);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      await routePlanService
        .onUnmappedUsersList({routeId: routeData.id, variantId: variantId})
        .then((response: any) => {
          if (response.students) {
            setTotalUnMappedUserData(response.students);
            setUnMappedUserData(response.students);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    };
    if (variantId && routeData.id) {
      //fetch mapped and un mapped users for the bp
      fetchData();
    }
  }, [variantId, routeData.id]);
  useEffect(() => {
    // console.log("from oldcurrent hook", oldCurrentVariantId);
    if (oldCurrentVariantId && oldCurrentVariantId !== 0) {
      const mappedUserIds = mappedUsersdata?.map(user => user.userId) || [];
      const newMappedUserIds = newlyMappedUsers?.map(user => user.userId) || [];
      const finalMappedUserIds = Array.from(
        new Set([...mappedUserIds, ...newMappedUserIds])
      );
      if (finalMappedUserIds.length === 0) {
        handlePopupModal();
      } else {
        setTimeout(() => {
          changeVariant();
        }, 100);
      }
    }
  }, [oldCurrentVariantId]);
  const handlePopupModal = () => {
    setProcessingPopupmodal(true);
  };
  // Mapped part start
  const removeMappedUser = (userId: string | undefined) => {
    // //get user id from event
    if (userId) {
      //find user from routeData.users
      const userToRemove = userData.users.find(user => user.userId === userId);
      // console.log("userToRemove", userToRemove);
      if (userToRemove && mappedUsersdata) {
        //remove user from mapped users list
        const updatedMappedUsers = mappedUsersdata.filter(
          user => user.userId !== userId
        );
        //console.log("updatedMappedUsers", updatedMappedUsers);
        setMappedUserData(updatedMappedUsers);

        //add user to unMapped users list
        const updatedUnMappedUsers = [...(newlyUnMappedUsers || [])];
        updatedUnMappedUsers.push({
          userId: userToRemove.userId || "",
          name: userToRemove.name,
          grade: userToRemove.className
        });
        // console.log("updatedUnMappedUsers", updatedUnMappedUsers);
        setNewlyUnMappedUsers(updatedUnMappedUsers);
      }
    }
  };

  const mapAgain = (userId: string | undefined) => {
    // console.log("mapAgain userId", userId);
    if (userId) {
      //find user from unMappedUsersdata
      const userToMap = userData.users?.find(user => user.userId === userId);
      // console.log("userToMap", userToMap);
      if (userToMap) {
        //remove user from unMapped users list
        const updatedUnMappedUsers = newlyUnMappedUsers?.filter(
          user => user.userId !== userId
        );
        // console.log("updatedUnMappedUsers", updatedUnMappedUsers);
        setNewlyUnMappedUsers(updatedUnMappedUsers || null);

        const updateMappedUsers = [...(mappedUsersdata || [])];
        updateMappedUsers.push(userToMap);
        // console.log("updateMappedUsers", updateMappedUsers);
        setMappedUserData(updateMappedUsers);
      }
    }
  };

  // Mapped part end

  //Un mapped part start
  const removeUnMappedUser = (userId: string | undefined) => {
    // //get user id from event
    if (userId && totalUnMappedUsersdata) {
      //find user from routeData.users
      const userToRemove = totalUnMappedUsersdata.find(
        user => user.userId === userId
      );
      //console.log("userToRemove", userToRemove);
      if (userToRemove && unMappedUsersdata) {
        //remove user from mapped users list
        const updatedMappedUsers = unMappedUsersdata.filter(
          user => user.userId !== userId
        );
        // console.log("updatedMappedUsers", updatedMappedUsers);
        setUnMappedUserData(updatedMappedUsers);

        //add user to unMapped users list
        const updatedUnMappedUsers = [...(newlyMappedUsers || [])];
        updatedUnMappedUsers.push(userToRemove);
        setNewlyMappedUsers(updatedUnMappedUsers);
      }
    }
  };

  const unMapAgain = (userId: string | undefined) => {
    // console.log("mapAgain userId", userId);
    if (userId) {
      //find user from unMappedUsersdata
      const userTounMap = totalUnMappedUsersdata?.find(
        user => user.userId === userId
      );
      // console.log("userToMap", userToMap);
      if (userTounMap) {
        //remove user from unMapped users list
        const updatedMappedUsers = newlyMappedUsers?.filter(
          user => user.userId !== userId
        );
        // console.log("updatedUnMappedUsers", updatedUnMappedUsers);
        setNewlyMappedUsers(updatedMappedUsers || null);

        const updateUnMappedUsers = [...(unMappedUsersdata || [])];
        updateUnMappedUsers.push(userTounMap);
        // console.log("updateUnMappedUsers", updateUnMappedUsers);
        setUnMappedUserData(updateUnMappedUsers);
      }
    }
  };
  //Un mapped part end

  //Rest data
  const resetData = () => {
    setMappedUserData(userData.users);
    setUnMappedUserData(totalUnMappedUsersdata);
    setNewlyMappedUsers([]);
    setNewlyUnMappedUsers([]);
  };
  //Save changes
  const saveChanges = async (optionType = "option1") => {
    // console.log(optionType);
    setConformModalOpen(false);
    const mappedUserIds = mappedUsersdata?.map(user => user.userId) || [];
    const newMappedUserIds = newlyMappedUsers?.map(user => user.userId) || [];
    const finalMappedUserIds = Array.from(
      new Set([...mappedUserIds, ...newMappedUserIds])
    );
    // console.log("mappedUserIds", mappedUserIds);
    // console.log("newMappedUserIds", newMappedUserIds);
    // console.log("finalMappedUserIds", finalMappedUserIds);
    //if (finalMappedUserIds.length > 0) {
    const requestData = {
      bpId: userData.id,
      type: 2, // 1 - Existing route, 2 - RO routes
      rtype: optionType === "option1" ? 0 : 2,
      userIds: finalMappedUserIds,
      routePlanVariantId: variantId
    };
    setSaveLoading(true);
    await routePlanService
      .mapUnmapUsers(requestData)
      .then((response: any) => {
        // console.log("mapUnmapUsers response", response);
        if (response?.status === "success") {
          if (finalMappedUserIds.length > 0) {
            // refreshSingleRoute(routeData.id, index);
            // handleCloseModal();
            setOldCurrentVariantId(variantId);
            setCurrentVariant(0);
          } else {
            setOldCurrentVariantId(variantId);
            setCurrentVariant(0);
          }
        } else {
          setApiErrorMessage(response?.message || "Failed to map/unmap users.");
        }
      })
      .finally(() => {
        setSaveLoading(false);
        setTimeout(() => {
          setApiErrorMessage("");
        }, 2000);
      });
    // }
  };

  const constractConformationMessage = () => {
    let message =
      "Are you sure you want to map/unMap users? This action cannot be undone.";
    if (
      newlyMappedUsers &&
      newlyMappedUsers.length > 0 &&
      newlyUnMappedUsers &&
      newlyUnMappedUsers.length > 0
    ) {
      message = `You are about to map ${newlyMappedUsers.length} user(s) and unmap ${newlyUnMappedUsers.length} user(s). ${message}`;
    } else if (newlyMappedUsers && newlyMappedUsers.length > 0) {
      message = `You are about to map ${newlyMappedUsers.length} user(s). ${message}`;
    } else if (newlyUnMappedUsers && newlyUnMappedUsers.length > 0) {
      message = `You are about to unmap ${newlyUnMappedUsers.length} user(s). ${message}`;
    } else {
      message = "No changes made to map/unmap users.";
    }
    const mappedUserIds = mappedUsersdata?.map(user => user.userId) || [];
    const newMappedUserIds = newlyMappedUsers?.map(user => user.userId) || [];
    const finalMappedUserIds = Array.from(
      new Set([...mappedUserIds, ...newMappedUserIds])
    );
    if (finalMappedUserIds.length === 0) {
      setConfirmPopup(true);
    } else {
      setConforMationMessage(message);
      setConformModalOpen(true);
    }
    //     const mappedUserIds = mappedUsersdata?.map(user => user.userId) || [];
    // const newMappedUserIds = newlyMappedUsers?.map(user => user.userId) || [];
    // let message = `There are ${mappedUsersdata?.length ?? 0} unmapped students and ${mappedCount} mapped students, out of a total of ${totalCount}. Do you want to continue?`;
  };

  const filteredUnMapped = useMemo(() => {
    return unMappedUsersdata?.filter(
      user =>
        user.name.toLowerCase().includes(inputSearch.toLowerCase()) ||
        user.grade?.toLowerCase().includes(inputSearch.toLowerCase())
    );
  }, [unMappedUsersdata, inputSearch]);

  const filteredNewUnMapped = useMemo(() => {
    return newlyUnMappedUsers?.filter(
      user =>
        user.name.toLowerCase().includes(inputSearch.toLowerCase()) ||
        user.grade?.toLowerCase().includes(inputSearch.toLowerCase())
    );
  }, [newlyUnMappedUsers, inputSearch]);
  const changeVariant = () => {
    //setProcessingPopupmodal(false);
    setCurrentVariant(oldCurrentVariantId);
    const routeId = routeData.id;
    if (routeId) {
      refreshSingleRoute(routeId, index);
    }
    setOldCurrentVariantId(0);
    handleCloseModal();
  };
  return (
    <div className="flex flex-col justify-center gap-2">
      <div className="flex items-center justify-between gap-4 border-b pb-3">
        <Image
          width={40}
          height={40}
          src="/icons/groups.png"
          alt="user mapping unmapping"
        ></Image>
        <div className="flex flex-col items-center">
          <span className="text-lg font-semibold">Users Mapping</span>
          <span className="text-sm text-gray-500">{userData?.name ?? ""}</span>
        </div>
        <div></div>
      </div>
      <div className="flex flex-col gap-2">
        <span className="text-sm text-gray-400">
          Mapped Users:{" "}
          <span
            className="rounded-md  bg-red-200 px-2 py-0.5 text-[10px] font-semibold text-black"
            title="Unmapped Count"
          >
            {newlyUnMappedUsers?.length || 0}
          </span>
          {" / "}
          <span
            className="rounded-md bg-yellow-400 px-2 py-0.5 text-[10px] font-semibold text-black"
            title="Total Mapped Count"
          >
            {userData.users.length || 0}
          </span>
        </span>
        <div className="flex max-h-60 flex-col overflow-y-auto">
          {/* newly mapped users (this users get from unmapped users to mapped users) */}
          {newlyMappedUsers &&
            newlyMappedUsers.length > 0 &&
            newlyMappedUsers.map((user: UnMappedUserItem) => (
              <div
                key={user?.userId}
                className="mb-1 flex items-center  justify-between rounded-md bg-green-200 p-2 px-4"
              >
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-medium text-gray-700">
                    {user.name}
                  </span>
                  <span className=" text-xs text-gray-500">{user.grade}</span>
                </div>

                <Tooltip content="Map/Unmap User(s)" showArrow color="primary">
                  <span
                    onClick={() => unMapAgain(user.userId)}
                    className="inline-flex cursor-pointer items-center justify-center"
                  >
                    <MdDelete />
                  </span>
                </Tooltip>
              </div>
            ))}
          {/* Its for already mapped uses list */}
          {mappedUsersdata && mappedUsersdata.length > 0 ? (
            mappedUsersdata.map((user: UserBoardingUser_RP) => (
              <div
                key={user?.userId || user.admissionNo}
                className="mb-1 flex items-center  justify-between rounded-md bg-gray-200 p-2 px-4"
              >
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-medium text-gray-700">
                    {user.name}
                  </span>
                  <span className=" text-xs text-gray-500">
                    {user.className}
                  </span>
                </div>
                <Tooltip content="Map/Unmap User(s)" showArrow color="primary">
                  <span
                    onClick={() => removeMappedUser(user.userId)}
                    className="inline-flex cursor-pointer items-center justify-center"
                  >
                    <MdDelete />
                  </span>
                </Tooltip>
              </div>
            ))
          ) : (
            <div className="py-4 text-center text-sm text-gray-500">
              {loading ? "Loading..." : "No mapped users found."}
            </div>
          )}
        </div>
      </div>
      {/* Un Mapped Users */}
      <div className="flex flex-col gap-2">
        <span className="text-sm text-gray-400">
          Available Users:{" "}
          <span
            className="rounded-md  bg-green-200 px-2 py-0.5 text-[10px] font-semibold text-black"
            title="Mapped Count"
          >
            {newlyMappedUsers ? newlyMappedUsers.length || 0 : 0}
          </span>
          {" / "}
          <span
            className="rounded-md  bg-yellow-400 px-2 py-0.5 text-[10px] font-semibold text-black"
            title="Total Unmapped Count"
          >
            {totalUnMappedUsersdata ? totalUnMappedUsersdata.length || 0 : 0}
          </span>
        </span>
        <NeoTextBox
          placeholder="Search Unmapped Users..."
          size="sm"
          value={inputSearch}
          onChange={e => setInputSearch(e.target.value)}
          className=""
        />
        <div className="flex max-h-60 flex-col overflow-y-auto">
          {filteredNewUnMapped &&
            filteredNewUnMapped.length > 0 &&
            filteredNewUnMapped.map((user: UnMappedUserItem) => (
              <div
                key={user.userId}
                className="mb-1 flex items-center justify-between rounded-md bg-red-200 p-2 px-4"
              >
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-medium text-gray-700">
                    {user.name}
                  </span>
                  <span className=" text-xs text-gray-500">{user.grade}</span>
                </div>
                {user.userId && (
                  <Tooltip content="Map Again" showArrow color="primary">
                    <span
                      onClick={() => mapAgain(user.userId)}
                      className="inline-flex cursor-pointer items-center justify-center"
                    >
                      <IoAddOutline />
                    </span>
                  </Tooltip>
                )}
              </div>
            ))}
          {filteredUnMapped && filteredUnMapped.length > 0 ? (
            filteredUnMapped.map((user: UnMappedUserItem) => (
              <div
                key={user.userId}
                className="mb-1 flex cursor-pointer items-center justify-between rounded-md bg-white p-2 px-4 shadow-md hover:bg-gray-50"
              >
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-medium text-gray-700">
                    {user.name}
                  </span>
                  <span className=" text-xs text-gray-500">{user.grade}</span>
                </div>
                <Tooltip content="Map Unmapped users" showArrow color="primary">
                  <span
                    onClick={() => removeUnMappedUser(user.userId)}
                    className="inline-flex cursor-pointer items-center justify-center"
                  >
                    <IoAddOutline />
                  </span>
                </Tooltip>
              </div>
            ))
          ) : (
            <div className="py-4 text-center text-sm text-gray-500">
              {loading ? "Loading..." : "No unmapped users found."}
            </div>
          )}
        </div>
      </div>
      {apiErrorMessage && (
        <span className="self-center text-sm text-red-500">
          {apiErrorMessage}
        </span>
      )}
      <div className="flex justify-end gap-2">
        <NeoButton
          type="button"
          color="white"
          className="gap-[5px] text-sm font-medium"
          disabled={loading}
          onClick={() => resetData()}
          size="sm"
        >
          Reset
        </NeoButton>
        <NeoButton
          type="button"
          color="yellow"
          className="gap-[5px] text-sm font-medium"
          //newMappedUserIds,mappedUserIds
          //
          disabled={
            loading ||
            (newlyMappedUsers?.length === 0 && newlyUnMappedUsers?.length === 0)
          }
          size="sm"
          onClick={constractConformationMessage}
          isLoading={saveLoading}
          spinner={
            <AiOutlineLoading size="xs" className="animate-spin h-6 w-6" />
          }
        >
          Save Changes
        </NeoButton>
      </div>
      <NeoModal
        actionType={"editVehicleConfirmation"}
        onOpen={conformModalOpen}
        onClose={() => setConformModalOpen(false)}
        onModalSubmit={() => saveChanges()}
        hasActions={true}
        data={{
          message:
            conforMationMessage ||
            "Are you sure you want to map/unMap users? This action cannot be undone."
        }}
        //selectedRow={rowsData}
      ></NeoModal>
      <NeoModal
        actionType={"boardingConformation"}
        onOpen={confirmPopup}
        onClose={() => setConfirmPopup(false)}
        hasActions={false}
        data={{
          message: {
            title: "Unmap User And Replan Route",
            options: {
              option1: {
                subTitle: "Unmap Users & Boarding Point",
                content:
                  "Unmap users and Boarding point from the route.The current route will remain unchanged."
              },
              option2: {
                subTitle: "Unmap User And Replan Route",
                content:
                  "Unmap User to this Boarding Point and re-optimize the route to exclude this stop, improving the route for the remaining boarding points."
              }
            }
          },
          onConfirm: saveChanges,
          reqData: {routeId: routeData.id}
        }}
      ></NeoModal>
      <NeoModal
        actionType={"routePlanProcessingPopup"}
        onOpen={processingPopupmodal}
        onClose={() => setProcessingPopupmodal(false)}
        hasActions={false}
        data={{
          changeVariant,
          newAddedVariantId: oldCurrentVariantId,
          type: "addBP"
        }}
      ></NeoModal>
    </div>
  );
};
